import { useIntl, getTranslatedText } from '@nile/components';

export default {
  title: {
    presence: {
      allowEmpty: false,
      message: () => {
        const intl = useIntl();
        return `^${getTranslatedText(intl, 'validation.description.empty')}`;
      }
    }
  },
  suspendedServices: {
    presence: {
      allowEmpty: false,
      message: () => {
        const intl = useIntl();
        return `^${getTranslatedText(
          intl,
          'validation.maintenance.pausedServices.empty'
        )}`;
      }
    }
  }
};
